import styled from "styled-components"

export const StyledSlider = styled.div`
  position: relative;
  display: flex;

  & .swiper-pagination-bullet-active {
    background: ${(props) => props.theme.colors.darkGrey80};
  }

  & .swiper-button-next,
  .swiper-button-prev {
    color: ${(props) => props.theme.colors.darkGrey80};
    top: auto;
    bottom: 8px;
  }

  & .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 32px;
  }

  & .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.colors.darkGrey};
  }

  & img,
  & video {
    width: 100%;
    object-fit: cover;
  }
`

export const StyledInstagramPost = styled.div`
  background: ${(props) => props.theme.colors.white};
  display: flex;
  position: relative;
  z-index: 1;
  margin: 0 auto;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    flex-direction: column;
  }
`

export const StyledImage = styled.img`
  max-height: 60vh;
  display: flex;
  margin: 0 auto;
`

export const StyledMedia = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  width: 100%;
  max-width: 50%;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    max-width: 100%;
  }

  background: ${(props) => props.theme.colors.darkGrey};

  & img,
  & video {
    width: 100%;
    object-fit: cover;
  }
`

export const StyledInfoWrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 50%;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    max-width: 100%;
  }
`

export const StyledReviewsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;

  & p {
    margin: 0;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
`

export const StyledInfo = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.darkGrey80};
  margin-top: 16px;
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
`

export const StyledTimestamp = styled.p``

export const StyledReviews = styled.div`
  display: flex;
`

export const StyledReview = styled.p`
  margin: 0;
  display: flex;

  p {
    padding-left: 4px;
  }

  svg {
    color: ${(props) => props.theme.colors.darkGrey80};
  }
`

export const StyledCaption = styled.p``

export const StyledUsername = styled.p`
  font-family: ${(props) => props.theme.fonts.circularBold};
  display: flex;
  align-items: center;
  gap: 4px;
  padding-bottom: 4px;
  color: ${(props) => props.theme.colors.darkGrey80};
`

export const StyledComment = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;

  svg {
    transform: scaleX(-1);
  }
`

export const StyledVideo = styled.video`
  max-height: 80vh;
`
